// extracted by mini-css-extract-plugin
export default {"iconWrapper":"CurrencyIcon_iconWrapper__FnOs9","icon":"CurrencyIcon_icon__ht8td"};